module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('strong', [_vm._v("Praise for Jenn Bennett and "), _c('em', [_vm._v("Kindling the Moon")])])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Jenn Bennett has written a great off-beat debut novel with a likeable heroine and a fun, original storyline. … I thoroughly enjoyed it and am eagerly awaiting a sequel—hopefully to come out soon!”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Karen Chance, "), _c('em', [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('em', [_vm._v("Death’s Mistress")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“"), _c('em', [_vm._v("Kindling the Moon")]), _vm._v(" engaged me from page one. I loved it! I immediately adored the heroine, Arcadia Bell. This book is packed from cover to cover with unpredictable twists, heart-pounding action, and heated sexual tension. … Jenn Bennett has definitely made my ‘To Buy’ list, and I’m looking forward to the next book in this series.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Anya Bast, "), _c('em', [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('em', [_vm._v("Cruel Enchantment")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“"), _c('em', [_vm._v("Kindling the Moon")]), _vm._v(" rocks like AC/DC on Saturday night. This book has it all: great writing, action, romance, a strong heroine, a unique hero, and the best teenager ever. I can’t wait for the next one.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Ann Aguirre, national bestselling author of "), _c('em', [_vm._v("Shady Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Debut author Jenn Bennett takes the familiar ideas of magic, demons, and mythology, and she gives us something sexy, fun, and genuinely unique in "), _c('em', [_vm._v("Kindling the Moon")]), _vm._v(". Arcadia Bell is a sassy, whip-smart addition to the growing pantheon of urban fantasy heroines, and Bennett an author to watch!”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Kelly Meding, author of "), _c('em', [_vm._v("Three Days to Dead")])])]), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("“Fantastic magic, nonstop action, and hot romance make "), _c('em', [_vm._v("Kindling the Moon")]), _vm._v(" a not-to-be-missed debut. Arcadia Bell is a tenacious and savvy heroine who had me hooked from the start.”")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "att"
  }, [_vm._v("—Linda Robertson, author of "), _c('em', [_vm._v("Arcane Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Delicious characters, fun twists, and fiendish risks. … This smart, stylish debut really delivers. Loved, loved, loved it!”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Carolyn Crane, author of "), _c('em', [_vm._v("Double Cross")])])]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('strong', [_vm._v("This title is also available as an eBook")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06efab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 66
// module chunks = 0